module.exports = __webpack_public_path__ + "img/temp-banner2.53ab6c80.png";